// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-hJ-","colMin":"styles_colMin__d9d0v"};